import { getAirportBusProviderBySlug } from "../providers";

/** Extracts the airport-bus provider slug from a transport URL path, if any. */
export function getAirportBusSlugFromPathname(pathname: string): string | null {
  const match = pathname.match(/\/transport\/([^/]+)/);
  const segment = match?.[1];
  if (!segment) {
    return null;
  }
  return getAirportBusProviderBySlug(segment) ? segment : null;
}

export function buildAirportBusBreadcrumbEntries(args: {
  language: string | null;
  pathname: string;
  airportBusOfferName?: string;
}): Array<{ href: string; show: boolean; name: string }> {
  const { language, pathname, airportBusOfferName } = args;
  const slug = getAirportBusSlugFromPathname(pathname);
  const provider = slug ? getAirportBusProviderBySlug(slug) : undefined;

  if (!provider) {
    return [];
  }

  const bookingPath = `/${language}/transport/${provider.slug}`;
  const confirmationPath = `${bookingPath}/confirmation`;
  const isOnConfirmation = pathname.includes(`/transport/${provider.slug}/confirmation`);

  return [
    {
      href: bookingPath,
      show: !isOnConfirmation,
      name: airportBusOfferName || provider.fallbackDisplayName
    },
    {
      href: confirmationPath,
      show: isOnConfirmation,
      name: "Confirmation"
    }
  ];
}
